import { useEffect, useState } from "react";
import { ContractOperationProductManage } from "src/api/contract/contract-types";
import { useApiOperation } from "src/api/hooks";
import { getProductDetailAsync, updateProductAsync } from "src/api/product/product-api";
import { ProductModel } from "src/api/product/product-types";
import { useToast } from "src/recoil/toast/hook";
import UserAccessSection from "./UserAccessSection";
import VisitorManageSection from "./VisitorManageSection";

type Props = {
  product: ProductModel;
};

const UserAndVisitorAccess = ({ product }: Props) => {
  const { openToast } = useToast();

  const [productInfo, setProduct] = useState<ProductModel>(product);

  const { executeAsync: getProductDetail } = useApiOperation(getProductDetailAsync);

  const { executeAsync: updateProduct } = useApiOperation(updateProductAsync);

  //  상세 - 최대인원 멤버 및 현재 이용자 수 확인
  const fetchProduct = async (id: string) => {
    const response = await getProductDetail({ productId: Number(id) }).catch(() => undefined);
    if (response) {
      const result = response.data.data.content;
      setProduct(result);
    }
  };

  useEffect(() => {
    if (product) {
      fetchProduct(String(product.id));
    }
  }, [product]);

  // 이용자 관리 - 최대 이용자수 변경
  const editProductManageData = async (data: any) => {
    if (data) {
      console.log("???", data);
      await updateProduct({ product: data });
      await fetchProduct(String(data.id));
      openToast({ content: "정상적으로 수정되었습니다.", type: "SUCCESS" });
    }
  };

  return (
    <>
      {/* 이용자 관리 */}
      <div className="contents-container__wrap-article">
        <UserAccessSection
          product={productInfo || {}}
          setData={(data: ContractOperationProductManage) => {
            if (data) {
              editProductManageData(data);
            }
          }}
        />
      </div>
      <div className="contents-container__wrap-article">
        {/* 방문자 관리 */}
        <VisitorManageSection
          product={productInfo || {}}
          onChangeVisitor={async (data: any) => {
            if (data) {
              await editProductManageData(data);
            }
          }}
        />
      </div>
    </>
  );
};

export default UserAndVisitorAccess;
